/* eslint-disable */
import { ASSISTED_USERS_MYSELF } from '@ringcentral-integration/commons/modules/RcVideo';
export default {
  scheduleFor: 'Ansetzen im Namen von',
  scheduleForAssistedUser:
    'Aktualisieren Sie die Besprechungseinstellungen im Namen von {userName}.',
  scheduleForGuidance:
    'Planen Sie einen Termin für jemand anderen?\n1. Stellen Sie sicher, dass Sie in ihrem Outlook-Kalender eingetragen sind.\n2. Wählen Sie in der Dropdown-Liste die Person aus, für die Sie den Termin planen möchten.\n',
  scheduleForGuidanceMore: 'Details erfahren.',
  meetingSettings: 'Besprechungseinstellungen',
  meetingSettingsDescription:
    'Die Updates werden nur auf diese Besprechung angewendet.',
  [ASSISTED_USERS_MYSELF]: 'Ich',
  waitingRoomTitle: 'Wartebereich verwenden',
  waitingRoomDescription:
    'Die Teilnehmer warten, bis Sie sie einlassen. Ideal für Vorstellungsgespräche oder externe Teilnehmer.',
  waitingRoomNotCoworker: 'Für jeden außerhalb meines Unternehmens',
  waitingRoomGuest: 'Für jeden, der nicht angemeldet ist',
  waitingRoomAll: 'Für alle Teilnehmer',
  enterPassword: 'Kennwort eingeben',
  onlyJoinAfterMe: 'Besprechung nach Ihrem Beitritt starten',
  allowJoinBeforeHostDescription:
    'Die Besprechung beginnt erst nach Ihrem Beitritt, um vorzeitige Konversationen zu vermeiden.',
  requirePassword: 'Kennwort anfordern',
  requirePasswordDescription:
    'Schützen Sie Ihre Besprechung. Jeder, der den Link verwendet, wird nicht zur Eingabe eines Kennworts aufgefordert.',
  password: 'Kennwort:',
  passwordEmptyError: 'Besprechungskennwort erforderlich',
  passwordInvalidError:
    'Ihr Kennwort muss 1–10 Buchstaben und Ziffern lang sein und darf keine Symbole enthalten',
  passwordHintText:
    'Ihr Kennwort muss 1–10 Buchstaben und Ziffern lang sein und darf keine Symbole enthalten.',
  usePersonalMeetingIdInstead: 'Persönlichen Besprechungslink verwenden',
  allowMeetingAccess: 'Verwalten, wer beitreten kann',
  anyoneWithLink: 'Alle mit Link',
  signedInUsers: 'Nur {shortName}-Konten',
  signedInCoWorkers: 'Nur meine Kollegen',
  passwordLabel: 'Kennwort',
  edit: 'Bearbeiten',
  editSettings: 'Einstellungen bearbeiten',
  lockTooltip:
    'Diese Einstellung wird von Ihrem Unternehmensadministrator verwaltet.',
  cancel: 'Abbrechen',
  update: 'Aktualisieren',
  pmiSettingsTitle: 'Persönliche Besprechungseinstellungen',
  pmiSettingsDescription:
    'Legen Sie für den persönlichen Besprechungslink fest, wer wie teilnehmen kann.',
} as const;

// @key: @#@"scheduleFor"@#@ @source: @#@"Schedule on behalf of"@#@
// @key: @#@"scheduleForAssistedUser"@#@ @source: @#@"Update meetings settings on behalf of {userName}."@#@
// @key: @#@"scheduleForGuidance"@#@ @source: @#@"Scheduling for someone else?\n1. Make sure you're on their Outlook calendar.\n2. From the dropdown, select the person you're scheduling for.\n"@#@
// @key: @#@"scheduleForGuidanceMore"@#@ @source: @#@"Learn details"@#@
// @key: @#@"meetingSettings"@#@ @source: @#@"Meeting settings"@#@
// @key: @#@"meetingSettingsDescription"@#@ @source: @#@"Updates will apply to this meeting only."@#@
// @key: @#@"ASSISTED_USERS_MYSELF"@#@ @source: @#@"Myself"@#@
// @key: @#@"waitingRoomTitle"@#@ @source: @#@"Use waiting room"@#@
// @key: @#@"waitingRoomDescription"@#@ @source: @#@"Participants wait until you admit them. Great for interviews or outside attendees."@#@
// @key: @#@"waitingRoomNotCoworker"@#@ @source: @#@"For anyone outside my company"@#@
// @key: @#@"waitingRoomGuest"@#@ @source: @#@"For anyone not signed in"@#@
// @key: @#@"waitingRoomAll"@#@ @source: @#@"For all participants"@#@
// @key: @#@"enterPassword"@#@ @source: @#@"Enter Password"@#@
// @key: @#@"onlyJoinAfterMe"@#@ @source: @#@"Start meeting after you join"@#@
// @key: @#@"allowJoinBeforeHostDescription"@#@ @source: @#@"The meeting will start after you join to prevent early conversations."@#@
// @key: @#@"requirePassword"@#@ @source: @#@"Require password"@#@
// @key: @#@"requirePasswordDescription"@#@ @source: @#@"Keep your meeting secure. Anyone using the link won't be prompted for a password."@#@
// @key: @#@"password"@#@ @source: @#@"Password:"@#@
// @key: @#@"passwordEmptyError"@#@ @source: @#@"Meeting password required"@#@
// @key: @#@"passwordInvalidError"@#@ @source: @#@"Your password must be 1-10 letters and numbers long but cannot contain symbols"@#@
// @key: @#@"passwordHintText"@#@ @source: @#@"Your password should be 1-10 letters and numbers long, but can not contain symbols."@#@
// @key: @#@"usePersonalMeetingIdInstead"@#@ @source: @#@"Use personal meeting link"@#@
// @key: @#@"allowMeetingAccess"@#@ @source: @#@"Manage who can join"@#@
// @key: @#@"anyoneWithLink"@#@ @source: @#@"Anyone with link"@#@
// @key: @#@"signedInUsers"@#@ @source: @#@"Only {shortName} accounts"@#@
// @key: @#@"signedInCoWorkers"@#@ @source: @#@"Only my coworkers"@#@
// @key: @#@"passwordLabel"@#@ @source: @#@"Password"@#@
// @key: @#@"edit"@#@ @source: @#@"Edit"@#@
// @key: @#@"editSettings"@#@ @source: @#@"Edit settings"@#@
// @key: @#@"lockTooltip"@#@ @source: @#@"This setting is managed by your company admin"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"update"@#@ @source: @#@"Update"@#@
// @key: @#@"pmiSettingsTitle"@#@ @source: @#@"Personal meeting settings"@#@
// @key: @#@"pmiSettingsDescription"@#@ @source: @#@"Set who can join and how for your personal meeting link."@#@
